/* eslint-disable no-await-in-loop */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/extensions */
import create, { GetState, SetState } from 'zustand';
import { persist } from 'zustand/middleware';
import { v4 as uuidv4 } from 'uuid';
import cnRes from './resources/cn.json';
import scRes from './resources/sc.json';
import enRes from './resources/en.json';
import config from './resources/config.json';

/** 打包时由 craco DefinePlugin 注入，格式 YYYYMMDDHHmm（精确到分钟），每次打包重新生成 */
const storeVersion =
  typeof process.env.CYBERSECURITY_STORE_VERSION !== 'undefined'
    ? Number(process.env.CYBERSECURITY_STORE_VERSION)
    : config.version;

const courselist = ['general-staff'];
interface PageSettings {
  language: string;
  settings: any;
  courses: any;
}
interface IParagraphState {
  id: string;
  state: 'not-start' | 'in-progress' | 'completed';
  components: any[];
}
interface ITopicState {
  id: string;
  state: 'not-start' | 'in-progress' | 'completed';
  paragraphStates: IParagraphState[];
}
export interface IQuizOption {
  title: string;
  isCorrect: false;
  explanation: string;
  sort: number;
}
export interface IQuizResult {
  id: string;
  question: string;
  options: IQuizOption[];
  answer: IQuizOption;
  quizIndex?: number;
}

interface IQuizResults {
  quizId: string;
  isCompleted: boolean;
  results: IQuizResult[];
  isPassed: boolean;
  score: number;
  datetime?: any;
}
interface ICourseState {
  id: string;
  language: string;
  state: 'not-start' | 'in-progress' | 'completed';
  progress: number;
  step: number;
  topicStates: ITopicState[];
  quizResults: IQuizResults[];
  currentQuizId: string | null;
}

interface PageState {
  language: string;
  pageSettings: PageSettings[];
  page: any | undefined;
  courses: any | undefined;
  courseState: ICourseState[];
  initPageSettings: () => Promise<void>;
  switchLanguage: (language: 'tc' | 'sc' | 'en') => void;
  setPageSettings: (language: 'tc' | 'sc' | 'en') => Promise<void>;
  getCourseState: (id: string) => ICourseState;
  setCourseState: (id: string, courseState: ICourseState) => void;
  getParagraphState: (courseId: string, topicId: string) => IParagraphState[];
  setParagraphState: (
    courseId: string,
    topicId: string,
    newState: IParagraphState[]
  ) => void;
  getTopicState: (courseId: string) => ITopicState[];
  updateParagraphState: (
    courseId: string,
    topicId: string,
    paragraphId: string,
    state: 'not-start' | 'in-progress' | 'completed',
    components: any[]
  ) => void;
  getQuizState: (courseId: string) => IQuizResults;
  setQuizAnswer: (
    courseId: string,
    quizId: string,
    resultId: string,
    answer: IQuizOption
  ) => void;
  reQuiz: (courseId: string) => IQuizResults;
}

/**
 * Cache in-flight init results so getters can return them immediately
 * without calling set() during React render (which triggers
 * "Cannot update a component while rendering a different component").
 */
const pendingCourseStates = new Map<string, ICourseState>();
const pendingQuizStates = new Map<
  string,
  { language: string; currentQuizId: string; quiz: IQuizResults }
>();
const scheduleStoreUpdate = (update: () => void) => {
  queueMicrotask(update);
};

const store = (set: SetState<PageState>, get: GetState<PageState>) => ({
  language: 'tc',
  pageSettings: [] as PageSettings[],
  page: undefined,
  courses: undefined,
  courseState: [] as ICourseState[],
  switchLanguage: (lang: 'tc' | 'sc' | 'en') => {
    get().setPageSettings(lang);
  },
  setPageSettings: async (language: any = 'tc') => {
    const c_courses: any = {};
    for (const courseId of courselist) {
      let resMod: any = {};
      if (language === 'tc') {
        resMod = await import(`./resources/courses/${courseId}/cn.json`);
      } else if (language === 'sc') {
        resMod = await import(`./resources/courses/${courseId}/sc.json`);
      } else if (language === 'en') {
        resMod = await import(`./resources/courses/${courseId}/en.json`);
      }
      c_courses[courseId] = resMod.default;
    }
    const courses = JSON.parse(JSON.stringify(c_courses));

    Object.keys(courses).forEach((courseId: string) => {
      const quizCount = courses[courseId]?.quizCount || 10;
      const quiz = courses[courseId].quiz?.map((itm: any, idx: number) => {
        const Quiz = courses[courseId]?.quiz[idx];
        return {
          options: Quiz.options.map((cnOption: any, optionIdx: number) => ({
            title: {
              [language]: Quiz.options[optionIdx]?.title,
            },
            explanation: {
              [language]: Quiz.options[optionIdx]?.explanation,
            },
            isCorrect: cnOption.isCorrect,
          })),
          question: {
            [language]: Quiz.question,
          },
        };
      });
      courses[courseId].quiz = quiz;
    });

    const pageSettings = [
      {
        language,
        settings: language === 'tc' ? cnRes : language === 'sc' ? scRes : enRes,
        courses,
      },
    ];
    set((state) => ({
      ...state,
      pageSettings,
      page: language === 'tc' ? cnRes : language === 'sc' ? scRes : enRes,
      language,
      courses,
    }));
  },
  initPageSettings: async () => {
    const language = 'tc';
    const { page } = get();
    if (page === undefined) {
      const c_courses: any = {};
      for (const courseId of courselist) {
        const resMod = await import(`./resources/courses/${courseId}/cn.json`);

        c_courses[courseId] = resMod.default;
      }
      const courses = JSON.parse(JSON.stringify(c_courses));

      Object.keys(courses).forEach((courseId: string) => {
        const quizCount = courses[courseId]?.quizCount || 10;
        const quiz = courses[courseId].quiz?.map((itm: any, idx: number) => {
          const Quiz = courses[courseId]?.quiz[idx];
          return {
            options: Quiz.options.map((cnOption: any, optionIdx: number) => ({
              title: {
                [language]: Quiz.options[optionIdx]?.title,
              },
              explanation: {
                [language]: Quiz.options[optionIdx]?.explanation,
              },
              isCorrect: cnOption.isCorrect,
            })),
            question: {
              [language]: Quiz.question,
            },
          };
        });
        courses[courseId].quiz = quiz;
      });

      const pageSettings = [
        {
          language,
          settings: cnRes,
          courses,
        },
      ];

      set((state) => ({
        ...state,
        pageSettings,
        page: cnRes,
        language,
        courses,
      }));
    }
  },
  getCourseState: (id: string) => {
    const state = get();
    const { courseState } = state;
    let currentCourse =
      courseState.find((itm) => itm.id === id) || pendingCourseStates.get(id);
    if (!currentCourse) {
      const courseSettings = state.courses[id];
      currentCourse = {
        id,
        language: get().language,
        progress: 0,
        step: 0,
        state: 'not-start',
        quizResults: [],
        currentQuizId: null,
        topicStates: courseSettings.topics.map((topic: any) => ({
          id: topic.id,
          state: 'not-start',
          paragraphStates: topic.paragraphs.map((p: any) => ({
            id: p.id,
            state: 'not-start',
          })),
        })),
      };
      pendingCourseStates.set(id, currentCourse);
      scheduleStoreUpdate(() => {
        const latest = get();
        const pending = pendingCourseStates.get(id);
        if (pending && !latest.courseState.find((itm) => itm.id === id)) {
          set({
            courseState: [...latest.courseState, pending],
          });
        }
        pendingCourseStates.delete(id);
      });
    }
    return currentCourse;
  },
  setCourseState: (id: string, newState: ICourseState) => {
    const state = get();
    set({
      ...state,
      courseState: state.courseState.map((itm) =>
        itm.id === id ? newState : itm
      ),
    });
  },
  getTopicState: (courseId: string) =>
    get().getCourseState(courseId)?.topicStates || [],
  getParagraphState: (courseId: string, topicId: string) =>
    get()
      .getCourseState(courseId)
      .topicStates.find((t) => t.id === topicId)?.paragraphStates || [],
  setParagraphState: (
    courseId: string,
    topicId: string,
    newState: IParagraphState[]
  ) => {
    const state = get();
    set({
      ...state,
      courseState: state.courseState.map((itm) =>
        itm.id !== courseId
          ? itm
          : {
              ...itm,
              topicStates: itm.topicStates.map((t) =>
                t.id !== topicId
                  ? t
                  : {
                      ...t,
                      state:
                        newState.filter((ns) => ns.state !== 'completed')
                          .length === 0
                          ? 'completed'
                          : 'in-progress',
                      paragraphStates: newState,
                    }
              ),
            }
      ),
    });
  },
  updateParagraphState: (
    courseId: string,
    topicId: string,
    paragraphId: string,
    newState: 'not-start' | 'in-progress' | 'completed',
    components: any[]
  ) => {
    const paragraphState = get().getParagraphState(courseId, topicId);
    get().setParagraphState(
      courseId,
      topicId,
      paragraphState.map((itm) =>
        itm.id === paragraphId
          ? {
              ...itm,
              state: newState,
              components,
            }
          : itm
      )
    );
  },
  getQuizState: (courseId: string) => {
    const currentCourseSettings = get().courses[courseId];
    const courseState = get().getCourseState(courseId);
    const language = get().language;
    const pendingQuiz = pendingQuizStates.get(courseId);
    let currentQuizResults = courseState.quizResults.find(
      (itm) => itm.quizId === courseState.currentQuizId
    );

    if (
      (currentQuizResults === undefined || courseState.language !== language) &&
      pendingQuiz &&
      pendingQuiz.language === language
    ) {
      return pendingQuiz.quiz;
    }

    if (currentQuizResults === undefined || courseState.language !== language) {
      const currentQuizId = uuidv4();
      const quizCount = currentCourseSettings.quizCount || 10;
      currentQuizResults = {
        quizId: currentQuizId,
        isCompleted: false,
        isPassed: false,
        score: 0,
        results: currentCourseSettings.quiz
          .slice(0, quizCount)
          .map((itm: any) => ({
            ...itm,
            id: uuidv4(),
            options: itm.options,
            answer: null,
          })),
      };

      pendingQuizStates.set(courseId, {
        language,
        currentQuizId,
        quiz: currentQuizResults,
      });

      scheduleStoreUpdate(() => {
        const pending = pendingQuizStates.get(courseId);
        if (!pending || pending.currentQuizId !== currentQuizId) {
          return;
        }
        const latest = get();
        const latestCourse =
          latest.courseState.find((itm) => itm.id === courseId) ||
          pendingCourseStates.get(courseId);
        if (!latestCourse) {
          pendingQuizStates.delete(courseId);
          return;
        }
        set({
          courseState: latest.courseState.some((itm) => itm.id === courseId)
            ? latest.courseState.map((itm) =>
                itm.id === courseId
                  ? {
                      ...itm,
                      language: pending.language,
                      currentQuizId: pending.currentQuizId,
                      quizResults: [
                        ...itm.quizResults.filter(
                          (q) => q.quizId !== pending.currentQuizId
                        ),
                        pending.quiz,
                      ],
                    }
                  : itm
              )
            : [
                ...latest.courseState,
                {
                  ...latestCourse,
                  language: pending.language,
                  currentQuizId: pending.currentQuizId,
                  quizResults: [
                    ...latestCourse.quizResults.filter(
                      (q) => q.quizId !== pending.currentQuizId
                    ),
                    pending.quiz,
                  ],
                },
              ],
        });
        pendingQuizStates.delete(courseId);
      });
    }
    return currentQuizResults;
  },
  setQuizAnswer: (
    courseId: string,
    quizId: string,
    resultId: string,
    answer: IQuizOption
  ) => {
    const state = get();
    const quizResults = state.getQuizState(courseId);
    const newResults = quizResults.results.map((r) =>
      r.id === resultId ? { ...r, answer } : r
    );
    const isCompleted = !newResults.some(
      (qr: IQuizResult, idx: number) => qr.answer === null
    );
    const currentCourseSettings = state.courses[courseId];
    const passScore = currentCourseSettings.quizPassScore || 80;
    const score =
      (newResults.filter((r) => r.answer && r.answer.isCorrect).length /
        newResults.length) *
      100;
    const isPassed = score >= passScore;
    set({
      ...state,
      courseState: state.courseState.map((itm) =>
        itm.id === courseId
          ? {
              ...itm,
              quizResults: itm.quizResults.map((result) =>
                result.quizId !== quizId
                  ? result
                  : {
                      quizId,
                      isCompleted,
                      isPassed,
                      score,
                      results: newResults,
                      // datetime: isCompleted ? new Date() : undefined,
                      datetime: '',
                    }
              ),
            }
          : itm
      ),
    });
  },
  reQuiz: (courseId: string) => {
    const currentCourseSettings = get().courses[courseId];
    const state = get();
    const courseState = state.getCourseState(courseId);
    const currentQuizId = uuidv4();
    const quizCount = currentCourseSettings.quizCount || 10;
    const newQuiz = currentCourseSettings.quiz
      .slice(quizCount, currentCourseSettings.quiz.length)
      .sort((a: any, b: any) => a.order - b.order);
    let quizResults = [];
    if (newQuiz.length >= quizCount) {
      quizResults = newQuiz.slice(0, quizCount);
    } else {
      const oddQuiz = currentCourseSettings.quiz
        .slice(0, quizCount)
        .map((itm: any) => ({
          ...itm,
          order: Math.random(),
        }))
        .sort((a: any, b: any) => a.order - b.order)
        .slice(0, quizCount - newQuiz.length);
      quizResults = newQuiz
        .concat(oddQuiz)
        .sort((a: any, b: any) => a.order - b.order)
        .slice(0, quizCount);
    }

    const currentQuizResults: IQuizResults = {
      quizId: currentQuizId,
      isCompleted: false,
      isPassed: false,
      score: 0,
      results: quizResults.map((itm: any) => ({
        ...itm,
        id: uuidv4(),
        answer: null,
      })),
    };
    // UPDATE State
    set({
      ...state,
      courseState: state.courseState.map((itm) =>
        itm.id === courseId
          ? {
              ...courseState,
              currentQuizId,
              quizResults: [...courseState.quizResults, currentQuizResults],
            }
          : itm
      ),
    });
    return currentQuizResults;
  },
});
export const useStore = create<PageState>(
  persist(store, {
    name: 'CybersecurityTrainingPageStore',
    version: storeVersion,
  })
);
